// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_ZpgTu {
  display: flex;
  flex-direction: column;
  gap: var(--size-padLarge);
}

.icon_Z_GjV {
  width: 24px;
}

.newCustomerContainer_uSucT {
  min-height: 624px;
}

.existingCustomerContainer_PkwRx {
  min-height: 357px;
}

.buttonsContainer_GsQ8_ {
  overflow: visible !important;
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/CustomerAccount.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padLarge);\n}\n\n.icon {\n  width: 24px;\n}\n\n.newCustomerContainer {\n  min-height: 624px;\n}\n\n.existingCustomerContainer {\n  min-height: 357px;\n}\n\n.buttonsContainer {\n  overflow: visible !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_ZpgTu`,
	"icon": `icon_Z_GjV`,
	"newCustomerContainer": `newCustomerContainer_uSucT`,
	"existingCustomerContainer": `existingCustomerContainer_PkwRx`,
	"buttonsContainer": `buttonsContainer_GsQ8_`
};
export default ___CSS_LOADER_EXPORT___;
